import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextPage, GetServerSideProps } from "next";
import styles from "./post.module.scss";
import Image from "next/image";
import one from "@images/home/22@2x.png";
import { getBlogDetail } from "@/service/index";
import { getBlogs } from "@/service/index";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import Layout from "@/components/layout";
import fb from "@images/report/icon_facebook.png";
import linkin from "@images/report/icon_Linkedin.png";
import tw from "@images/report/icon_Twitter.png";
import fb2 from "@images/report/facebook.png";
import linkin2 from "@images/report/instagram.png";
import tw2 from "@images/report/twitter.png";
import { useEffect, useState } from "react";
import Item from "antd/lib/list/Item";
import dayjs from "dayjs";
import { getLangLink } from "@/utils/lang";
import { useWidth } from "@/utils/resize";
type postType = {
  post: any;
  previousPost: any;
  nextPost: any;
  relatedPosts: any[];
};
const Post: NextPage<{
  Data: any;
}> = (props) => {
  const { width, display } = useWidth();
  const router = useRouter();
  const { locales, locale: activeLocale } = router;
  const Data: any = props.Data;

  const { t } = useTranslation("blog");
  const { post, previousPost, nextPost, relatedPosts }: postType = Data;
  const [xValue, setXValue] = useState(false); //false 表示大于768px
  const doAdRequest  = () => {
    setTimeout(()=> {
      try {
        // @ts-ignore
       (adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.log(e, "ad error")
      }

    },200)

  }
  //解决768px blog主图不能全屏
  useEffect(() => {
    const handleResize = (setXValue: any) => {
      if (typeof window !== "undefined") {
        var screenW = document.body.clientWidth;
        if (screenW <= 768) {
          setXValue(true);
        } else {
          setXValue(false);



        }
      }
    };
    if (typeof window !== "undefined") {
      var screenW = document.body.clientWidth;
      if (screenW > 768) {
        doAdRequest()
        doAdRequest()
      }
    }

    handleResize(setXValue);
    window.addEventListener("resize", (e) => handleResize(setXValue), false);
    return () => {
      window.addEventListener("resize", (e) => handleResize(setXValue), false);
    };
  }, []);

  return (
    <Layout header={true} footer={true}>
      <div className={styles.post + " lg1024:pt-[70px]"}>
        <Head>
          <title>
            {post?.seoTitle || "TikTok Online Analytics Tool | TikMeta Insight"}
          </title>
          <meta
            name="keywords"
            content={
              post?.seoTitle ||
              "tiktok online analytics tool, tiktok user analytics, tiktok account analytics,tiktok influencer analytics,tiktok video downloader,download without watermark, how to see tiktok analytics"
            }
          />
          <meta
            name="description"
            content={post?.seoDesc || "tiktok online analytics tool"}
          />
          <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8125078577529458"
 crossOrigin="anonymous"></script>
          <script async
                  src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9647300350195778"
                  crossOrigin="anonymous"></script>
        </Head>
        <div className={styles.container + " defeaultContainer"}>
          <div className={styles.share_wrap}>
            <a
              target={"_blank"}
              href={`http://www.linkedin.com/shareArticle?mini=true&ro=true&title=${
                post?.title
              }&url=${
                process.env.NEXT_PUBLIC_PORTAL_URL + "/blogs/" + post?.seoUrl
              }&armin=armin`}
              className="mr-[16px]"
              rel="noreferrer"
            >
              <Image width={24} height={24} src={linkin2} alt=""></Image>
            </a>
            <a
              target={"_blank"}
              href={`https://www.facebook.com/sharer/sharer.php?u=${
                process.env.NEXT_PUBLIC_PORTAL_URL + "/blogs/" + post?.seoUrl
              }`}
              className="mr-[16px]"
              rel="noreferrer"
            >
              <Image width={24} height={24} src={fb2} alt=""></Image>
            </a>
            <a
              target={"_blank"}
              href={`https://twitter.com/intent/tweet?text=${post?.title}&url=${
                process.env.NEXT_PUBLIC_PORTAL_URL + "/blogs/" + post?.seoUrl
              }`}
              rel="noreferrer"
            >
              <Image width={24} height={24} src={tw2} alt=""></Image>
            </a>
          </div>
          <div className={styles.details}>
            <a
              href={
                process.env.NEXT_PUBLIC_PORTAL_URL +
                getLangLink("", activeLocale)
              }
              className="!text-[#708096] hover:!text-[#ff3e5f]"
            >
              {t("Home")}
            </a>
            <span className="text-[#708096]"> / </span>
            <a href={getLangLink("/blogs", activeLocale)}>
              {t("Blogs")}
            </a> / {t("details")}
          </div>
          <div className="bg-[#fff] p-[40px] mt-[20px] rounded-[8px] lg1024:p-0 relative">
          {width > 768 && <div className={`${styles.adbanner_box} relative`}>
            <div className={`${styles.adbanner}`}>
            <ins className="adsbygoogle"
     style={{display:'inline-block', width: '120px', height: '600px'}}
     data-ad-client="ca-pub-8125078577529458"
     data-ad-slot="2346591929"></ins>

            </div>
            </div>}
            <div
              className={
                styles.title + " lg1024:!text-[18px] lg1024:!leading-[28px]"
              }
            >
              {post?.title}
            </div>

            <div
              className={
                styles.time +
                " lg1024:!text-[18px] flex items-center justify-between lg1024:w-full"
              }
            >
              <div className="flex items-center justify-between flex-wrap lg1024:w-full">
                <div className="flex items-center lg1024:w-full lg1024:mb-[10px]">
                  {post?.authorPic ? (
                    <Image
                      src={post?.authorPic}
                      width={32}
                      height={32}
                      alt=""
                    ></Image>
                  ) : null}
                  {post?.author && (
                    <span className="ml-[16px] mr-[26px] text-[16px] text-[#0A122C]">
                      {post?.author}
                    </span>
                  )}
                </div>
                {post?.createTime ? (
                  <span className="lg1024:text-[14px]">
                    {dayjs(post?.createTime).format("YYYY-MM-DD ")}
                  </span>
                ) : (
                  ""
                )}
                <div className={styles.share_mobile}>
                  <a
                    target={"_blank"}
                    href={`http://www.linkedin.com/shareArticle?mini=true&ro=true&title=${
                      post?.title
                    }&url=${
                      process.env.NEXT_PUBLIC_PORTAL_URL +
                      "/tiktok-reports/" +
                      post?.seoUrl
                    }&armin=armin`}
                    className="mr-[16px]"
                    rel="noreferrer"
                  >
                    <Image width={24} height={24} src={linkin} alt=""></Image>
                  </a>
                  <a
                    target={"_blank"}
                    href={`https://www.facebook.com/sharer/sharer.php?u=${
                      process.env.NEXT_PUBLIC_PORTAL_URL +
                      "/tiktok-reports/" +
                      post?.seoUrl
                    }`}
                    className="mr-[16px]"
                    rel="noreferrer"
                  >
                    <Image width={24} height={24} src={fb} alt=""></Image>
                  </a>
                  <a
                    target={"_blank"}
                    href={`https://twitter.com/intent/tweet?text=${
                      post?.title
                    }&url=${
                      process.env.NEXT_PUBLIC_PORTAL_URL +
                      "/tiktok-reports/" +
                      post?.seoUrl
                    }`}
                    rel="noreferrer"
                  >
                    <Image width={24} height={24} src={tw} alt=""></Image>
                  </a>
                </div>
              </div>
            </div>

            <div
              style={{ maxWidth: "990Px" }}
              dangerouslySetInnerHTML={{
                __html: post?.content,
              }}
              className={styles.works}
            />


            {post?.author ? (
              <div className="flex p-[30px] bg-[#F7F8FA] rounded-[8px] mt-[65px] lg1024:p-[20px]">
                {width > 1024 && post?.authorPic && (
                  <div>
                    <Image
                      src={post?.authorPic}
                      width={80}
                      height={80}
                      alt=""
                    ></Image>
                  </div>
                )}
                <div className="flex-1 ml-[20px] lg1024:ml-0">
                  <div className="lg1024:flex items-center">
                    {width < 1024 && post?.authorPic && (
                      <div>
                        <Image
                          src={post?.authorPic}
                          width={40}
                          height={40}
                          alt=""
                        ></Image>
                      </div>
                    )}
                    <h4 className="text-[16px] text-[#0A122C] mb-[14px] lg1024:mb-0 lg1024:ml-[20px]">
                      {post?.author}
                    </h4>
                  </div>
                  <div className="my-0 text-[16px] leading-[18px] !text-[#191919] lg1024:mt-[16px] lg1024:text-[12px] lg1024:leading-[14px]">
                    {post?.authorDesc}
                  </div>
                </div>
              </div>
            ) : null}

            {/* 上下篇 */}

            <div className={styles.preNext}>
              {previousPost ? (
                <a
                  href={getLangLink(
                    `/blogs/${previousPost?.seoUrl}`,
                    activeLocale
                  )}
                  title={previousPost?.title}
                >
                  <div className={styles.Pre}>
                    <div
                      className={styles.pre}
                      style={{ justifyContent: "flex-end" }}
                    >
                      <div className={styles.pn + " lg1024:!text-[14px]"}>
                        {t("pre")}
                      </div>
                      <div className={styles.arrow + " lg1024:!text-[12px]"}>
                      ←
                      </div>
                    </div>
                    <div className={styles.pnTitle}>
                      <a>
                        <span
                          style={{ display: "block" }}
                          className="lg1024:!hidden"
                        >
                          {previousPost.title}
                        </span>
                      </a>
                    </div>
                  </div>
                </a>
              ) : null}
              {nextPost ? (
                <a
                  href={getLangLink(`/blogs/${nextPost?.seoUrl}`, activeLocale)}
                  title={nextPost?.title}
                >
                  <div className={styles.Pre}>
                    <div className={styles.pre}>
                      <div
                        className={styles.arrow + " lg1024:!text-[12px]"}
                        style={{ marginLeft: "0" }}
                      >
                        →
                      </div>
                      <div className={styles.pn + " lg1024:!text-[14px]"}>
                        {t("next")}
                      </div>
                    </div>
                    <div className={styles.pnTitle}>
                      <a
                        title={nextPost?.seoTitle}
                        style={{ display: "block" }}
                        className="lg1024:!hidden"
                      >
                        {nextPost.title}
                      </a>
                    </div>
                  </div>
                </a>
              ) : (
                <div></div>
              )}
            </div>
          </div>
          {/* <hr className={styles.hr} /> */}
          {/* 相关文章 */}
        </div>

        <div className={styles.related + " defeaultContainer"}>
          <div
            className={
              styles.reTitle + " lg1024:!text-[20px] lg1024:!my-[65px]"
            }
          >
            {t("related")}
          </div>
          <div className={styles.blogList}>
            {(relatedPosts || []).map((item, index) => (
              <div className={styles.item + " lg1024:!mb-[30px]"} key={index}>
                <div className={styles.pic}>
                  <a
                    href={getLangLink(`/blogs/${item?.seoUrl}`, activeLocale)}
                    title={item.seoTitle}
                  >
                    <Image
                      lazyBoundary="10px"
                      src={item.cover ? item.cover : one}
                      width={xValue ? 768 : 430}
                      height={xValue ? 450 : 300}
                      objectFit="cover"
                      style={{
                        borderRadius: "16Px",
                      }}
                      alt={item?.seoTitle}
                    ></Image>
                  </a>
                </div>
                <div
                  className={
                    styles.title +
                    " lg1024:!text-[16px] lg1024:!mt-[4px] lg1024:!leading-[24px] lg1024:!min-h-0"
                  }
                >
                  {item.title}
                </div>
                <div className={styles.time + " lg1024:!mt-[8px]"}>
                  {item.createTime
                    ? dayjs(item.createTime).format("YYYY-MM-DD ")
                    : ""}
                </div>
                <div
                  className={
                    styles.desc +
                    " lg1024:!min-h-0 lg1024:!text-[14px] lg1024:!leading-[20px]"
                  }
                >
                  {item.desc}
                </div>
                <div className={styles.read + " lg1024:!mt-[0px]"}>
                  <a
                    href={getLangLink(`/blogs/${item?.seoUrl}`, activeLocale)}
                    className={styles.more}
                    title={item.seoTitle}
                  >
                    {t("readmore")} &#8594;
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale, params } = context;
  //fetch 获取blog 为id 的文章数据;
  const res = await getBlogDetail({
    seoUrl: params?.seoUrl,
    language: "en",
    context,
  });

  if (!res.data) {
    return {
      notFound: true
    }
  }

  console.log(res, '2222')

  const detailData = (res && res.data) || [];

  if (detailData.post?.content) {
    let content = detailData.post.content
    let secondH2Index = content.indexOf('<h2', content.indexOf('<h2') + 1);
    console.log(secondH2Index, 'secondH2Index')
    let  newText = content.slice(0, secondH2Index) + `
    <ins class="adsbygoogle"

     style="display:block"

     data-ad-client="ca-pub-8125078577529458"

     data-ad-slot="4486688039"

     data-ad-format="auto"

     data-full-width-responsive="true"></ins>
` + content.slice(secondH2Index);
    console.log(newText)
    detailData.post.content = newText
  }
  return {
    props: {
      ...(await serverSideTranslations(locale!, [
        "common",
        "nav",
        "blog",
        "about",
        "footer",
      ])),
      // Will be passed to the page component as props
      // Data: res.data,
      Data: detailData,

    },
  };
};
export default Post;
